export const studentsListIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Student List is where you can view your whole WordFlight roster. You can add, edit, and delete students on this page.'
  },
  {
    element: '#filters-wrapper',
    intro: 'Use these filters to narrow down the students by teacher, grade or class.'
  },
  {
    element: '.show-coteacher-checkbox',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the student list will only display those you are directly assigned to- excluding any students you’re listed as a co-teacher for.'
  },
  {
    element: '#export-button',
    intro: 'Click here to export the Student List.',
  },
  {
    element: '#print-button',
    intro: 'Click here to print the student list.'
  },
  {
    element: '#addButton',
    intro: 'Click here to add new students to your WordFlight roster.'
  },
  {
    element: '#addCleverSections',
    intro: 'Click here to add Clever sections to your WordFlight roster.'
  },
  {
    element: '#addClasslinkSections',
    intro: 'Click here to add ClassLink sections to your WordFlight roster.'
  },
  {
    element: '#bulk-edit-button',
    intro: 'Click here to bulk edit the settings for the selected students.',
  },
  {
    element: '#deleteButton',
    intro: 'Click here to archive the selected student from your account. The student’s data will also be archived.'
  },
  {
    element: 'table.report-table tbody tr:first-child button[title="Edit Student"]',
    intro: 'Click here to edit your student’s account and settings. This allows you to edit the student’s name, username, password, grade, class, session time, and in program settings.'
  },
];
